<div class="hero-bg hero-bg-contact">
  <app-navbar/>
  <div class="d-flex flex-column justify-content-center hero-header">
    <div class="app-container">
    </div>
  </div>
</div>
